import { useEffect, useState } from 'react';
import { getAllSerialNumbers } from 'src/api/stoApi';

export function useAllSerialNumbers(assetId: string, page: number, pageSize = 25) {
  const [serialNumbers, setSerialNumbers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSerialNumbers = async () => {
      try {
        const response = await getAllSerialNumbers(assetId, page, pageSize);
        setSerialNumbers(response.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchSerialNumbers();
  }, [assetId, page, pageSize]);

  return { serialNumbers, loading };
}
